import type { ThemeNames } from '@sravni/design-system-theme';

import { PARTNERS_CUSTOM_THEME } from '../config/customTheme';
import { DefaultStylesWrapper } from '../ui/StylesWrapper/DefaultStylesWrapper';

export const getThemeByAffId = (affId: number | null | undefined, defaultTheme: ThemeNames) => {
  if (!affId) {
    return { themeName: defaultTheme, Component: DefaultStylesWrapper };
  }

  return (
    PARTNERS_CUSTOM_THEME[affId as keyof typeof PARTNERS_CUSTOM_THEME] ?? {
      themeName: defaultTheme,
      Component: DefaultStylesWrapper,
    }
  );
};
